import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'retired-sa-invoice-header',
  templateUrl: './retired-sa.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./retired-sa.css']
})
export class RetiredSaInvoiceHeaderComponent {}
